import { Alert, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

export const NoObjectsToArchive = () => {
  const { t } = useTranslation(['workflowCompletions']);

  return (
    <Alert severity='info'>
      <Typography variant='bodyLarge'>
        {t('workflowCompletions:archiveObjects.noObjectsToArchive')}
      </Typography>
    </Alert>
  );
};
